module.exports = __webpack_public_path__ + "img/cehui.4a2856ee.png";